import ComingSoon from '../modules/coming-soon'
import Page from '../modules/page'

Page.register(ComingSoon)
